import { Alert } from '@treezor/design-system';

import { useAlert } from '@/ui-kit/alerts/useAlert';
import { useExpirationStatus } from '@/features/dashboard-users/hooks/useexpirationStatus';
import { useCurrentSupportUser } from '@/features/dashboard-users/hooks/useCurrentSupportUser';
import { DateText } from '@/ui-kit/Date/DateText';

export function AccessExpirationAlert() {
  const { t, handleAlertClose, alertClasses } = useAlert('accessExpirationWarning');
  const currentSupportUser = useCurrentSupportUser();
  const { accessExpirationDate } = useExpirationStatus(currentSupportUser);

  const description = (
    <div className="typo-body-regular-small">
      <p>
        {t('pages.administration.supportsUsers.alert.content')}{' '}
        <DateText size="xs" date={accessExpirationDate} className="typo-body-semibold-small"></DateText>.{' '}
        {t('pages.administration.supportsUsers.alert.action')}
      </p>
    </div>
  );

  return (
    <Alert
      title={t('pages.administration.supportsUsers.alert.title')}
      description={description}
      isClosable
      variant="secondary"
      type="warning"
      onClose={handleAlertClose}
      className={alertClasses}
    />
  );
}
